import { Pill, HeartPulse, Layers, User, UserRound, LifeBuoy } from "lucide-react";

export const services = [
  {
    Icon: Pill,
    title: "Tratamiento de adicciones",
    text: "Programa de rehabilitación para el consumo de alcohol, drogas, medicamentos y codependencia, con desintoxicación supervisada y prevención de recaídas.",
  },
  {
    Icon: HeartPulse,
    title: "Salud mental",
    text: "Acompañamiento para ansiedad, depresión, trastornos del estado de ánimo y de la personalidad, con evaluación psiquiátrica y terapia individual.",
  },
  {
    Icon: Layers,
    title: "Patología dual",
    text: "Cuando la adicción convive con un trastorno mental, la tratamos de forma conjunta con interconsulta en psiquiatría y neurología.",
  },
  {
    Icon: User,
    title: "Sucursal para hombres",
    text: "Un entorno acogedor y respetuoso, donde cada hombre recibe cuidado de calidad adaptado a sus necesidades.",
  },
  {
    Icon: UserRound,
    title: "Sucursal para mujeres",
    text: "Un espacio seguro, confortable y digno, con atención especializada enfocada en las necesidades únicas de cada mujer.",
  },
  {
    Icon: LifeBuoy,
    title: "Intervención en crisis",
    text: "Atención 24/7 y acompañamiento respetuoso a la familia cuando la situación requiere una respuesta inmediata.",
  },
];

export const stats = [
  { value: "+5,000", label: "personas han mejorado su vida" },
  { value: "+16", label: "profesionales en el equipo" },
  { value: "45–90", label: "días de programa residencial" },
  { value: "2", label: "sucursales: hombres y mujeres" },
];

export const heroTrust = [
  { value: "+27", label: "años de experiencia clínica" },
  { value: "86%", label: "índice de satisfacción" },
  { value: "7 días", label: "atención a familias" },
];

export const phases = [
  {
    n: "01",
    title: "Valoración inicial y diagnóstico",
    text: "Entrevista y evaluación médica y psicológica, con estudios de laboratorio, para entender el estado de salud y detectar posible patología dual.",
  },
  {
    n: "02",
    title: "Plan de tratamiento personalizado",
    text: "Aplicación de pruebas psicológicas y un plan 100% individual. De existir patología dual, interconsulta con psiquiatría y neurología.",
  },
  {
    n: "03",
    title: "Tratamiento integral",
    text: "Terapia individual y grupal, activación física, grupos de ayuda mutua y seguimiento profesional de los avances.",
  },
  {
    n: "04",
    title: "Reinserción y proyecto de vida",
    text: "Acompañamos a cada persona a elaborar su proyecto de vida y a reintegrarse a la sociedad, con herramientas para prevenir recaídas.",
  },
];

export const creds = [
  { name: "COFEPRIS", text: "Aviso de funcionamiento y responsable sanitario del establecimiento." },
  { name: "NOM-028-SSA2", text: "Norma para la prevención y atención de las adicciones." },
  { name: "NOM-178-SSA1", text: "Norma de operación de establecimientos de atención médica." },
  { name: "CLUNI · OSC", text: "Registro como Organización de la Sociedad Civil ante la Secretaría de Bienestar." },
];

export const hopeMessages = [
  { text: "Volví a escuchar reír a mi hijo. Hoy hay calma en casa donde antes solo había miedo.", who: "Una madre" },
  { text: "Nos enseñaron que acompañar no es rescatar. Aprendimos a cuidarnos también nosotros.", who: "Un padre" },
  { text: "Encontramos un trato digno y humano. Por primera vez sentimos que no estábamos solos.", who: "Una hermana" },
  { text: "El proceso fue lento y honesto. Recuperamos, poco a poco, las conversaciones y la confianza.", who: "Una esposa" },
];

export const faqItems = [  {
    q: "¿Cuánto dura el tratamiento?",
    a: "Contamos con dos planes residenciales, de 45 y 90 días. El plan se define en la valoración inicial según las necesidades de cada persona.",
  },
  {
    q: "¿El paciente debe ingresar por voluntad propia?",
    a: "Lo ideal es que sí. Sin embargo, muchas veces la persona está confundida o desgastada y no puede decidirlo con claridad. Por eso acompañamos a la familia y ofrecemos un servicio de intervención en crisis para abordar la situación de forma respetuosa.",
  },
  {
    q: "¿Hay terapia para la familia?",
    a: "Sí. La familia es determinante en la recuperación. Ofrecemos terapias grupales sabatinas y terapia familiar individual para que el proceso avance en la misma dirección.",
  },
  {
    q: "¿En CESMA hay maltrato hacia los pacientes?",
    a: "No. Nuestro modelo es completamente humanista y congruente con nuestros valores. El trato digno y respetuoso es la base de todo el tratamiento.",
  },
  {
    q: "¿Dónde está ubicada la clínica?",
    a: "En Lisboa 9, Col. Burgos, Cuernavaca, Morelos, una de las zonas más tranquilas de la ciudad. Atendemos los 7 días de la semana. Teléfono y WhatsApp: 777 555 7088.",
  },
];
